export default __webpack_public_path__ + "static/media/breakfastHealthgenom.34507af6.svg";